import React from "react";
import { Card, CardBody, CardHeader, HStack, Heading, Icon, Text } from "@chakra-ui/react";

const PlaceholderPanel = ({ title, description, icon }) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack spacing={3}>
          {icon ? <Icon as={icon} color="blue.500" /> : null}
          <Heading size="sm">{title}</Heading>
        </HStack>
      </CardHeader>
      <CardBody>
        <Text color="gray.600">{description}</Text>
      </CardBody>
    </Card>
  );
};

export default PlaceholderPanel;
